import { Link } from "react-router-dom";
import { ArrowRight, Heart, Brain, Activity, Wind, Users, Sun, GraduationCap, Compass, Sparkles } from "lucide-react";

const SERVICES = [
  { icon: Heart, title: "Individual Counselling", desc: "One-on-one sessions personalised to your unique story, struggles, and goals." },
  { icon: Sun, title: "Emotional Support", desc: "A consistent, compassionate presence during difficult chapters of life." },
  { icon: Activity, title: "Stress Management", desc: "Practical tools to regulate the nervous system and return to steadiness." },
  { icon: Wind, title: "Anxiety Support", desc: "Understand the patterns of anxiety and learn to live alongside them gently." },
  { icon: Users, title: "Relationship Concerns", desc: "Navigate communication, boundaries, conflict, and connection — with yourself and others." },
  { icon: Sparkles, title: "Self-Esteem & Confidence", desc: "Rebuild your relationship with yourself from the inside out." },
  { icon: GraduationCap, title: "Student Counselling", desc: "Support for academic pressure, exam anxiety, identity, and transitions." },
  { icon: Compass, title: "Career Guidance", desc: "Clarify what matters, untangle indecision, and move forward with intention." },
  { icon: Brain, title: "Personal Growth & Well-Being", desc: "Explore meaning, build healthy habits, and grow into the version of you you're becoming." },
];

export default function Services() {
  return (
    <div data-testid="services-page">
      <section className="container-soft pt-16 md:pt-24 pb-10">
        <div className="text-xs uppercase tracking-[0.25em] mb-4" style={{ color: "var(--primary-deep)" }}>Services</div>
        <h1 className="font-display text-5xl sm:text-6xl mb-6 max-w-3xl" style={{ color: "var(--text-primary)" }}>
          Support shaped around <em className="not-italic" style={{ color: "var(--primary-deep)"}}>you</em>.
        </h1>
        <p className="max-w-2xl text-lg leading-relaxed" style={{ color: "var(--text-secondary)" }}>
          Every session is collaborative, confidential, and grounded in warmth. All sessions are conducted online via a secure audio or video call.
        </p>
      </section>

      <section className="container-soft py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s) => (
            <div key={s.title}
              className="rounded-3xl p-8 transition-all hover:-translate-y-1 hover:shadow-md flex flex-col h-full"
              style={{ background: "var(--surface)", border: "1px solid var(--border-soft)" }}
              data-testid={`service-${s.title.replace(/\s+/g, '-').toLowerCase()}`}
            >
              <div className="w-12 h-12 rounded-full flex items-center justify-center mb-5" style={{ background: "var(--accent-lavender)" }}>
                <s.icon size={20} style={{ color: "var(--primary-deep)" }}/>
              </div>
              <h3 className="font-display text-2xl mb-3" style={{ color: "var(--text-primary)" }}>{s.title}</h3>
              <p className="text-sm leading-relaxed" style={{ color: "var(--text-secondary)" }}>{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="container-soft py-20 text-center">
        <p className="mb-6 max-w-xl mx-auto" style={{ color: "var(--text-secondary)" }}>
          Not sure which service is right for you? Reach out and we'll figure it out together.
        </p>
        <Link to="/booking" className="inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-sm" style={{ background: "var(--primary)", color: "#fff" }} data-testid="services-book-btn">
          Book a Consultation <ArrowRight size={16}/>
        </Link>
      </section>
    </div>
  );
}
